import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import NavBar from '../components/layout/NavBar'
import { listClientOffers, type ClientOfferListItem } from '../api/offers'

export default function OffersListPage() {
  const [items, setItems] = useState<ClientOfferListItem[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(null)
    listClientOffers()
      .then((data) => {
        if (!cancelled) setItems(Array.isArray(data?.results) ? data.results : [])
      })
      .catch((e: any) => {
        if (!cancelled) setError(e?.response?.data?.detail || e?.message || 'Failed to load offers.')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className="min-h-screen">
      <NavBar />
      <main className="mx-auto max-w-5xl space-y-4 px-4 py-6">
        <h1 className="text-2xl font-bold">Offers</h1>
        <p className="text-sm text-white/70">Quotes sent to you by pros.</p>

        {loading ? <div className="rounded-xl border border-white/10 bg-white/5 p-4 text-sm text-white/70">Loading offers...</div> : null}
        {error ? <div className="rounded-xl border border-red-400/30 bg-red-500/10 p-3 text-sm text-red-200">{error}</div> : null}
        {!loading && !error && items.length === 0 ? (
          <div className="rounded-xl border border-white/10 bg-white/5 p-4 text-sm text-white/70">No offers yet.</div>
        ) : null}

        <div className="space-y-2">
          {items.map((item) => (
            <Link key={item.offer_id} to={`/offers/${item.offer_id}`} className="block rounded-xl border border-white/10 bg-white/5 p-4 hover:bg-white/10">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div className="text-sm font-semibold text-white">{item.title || 'Offer'}</div>
                <span className="rounded-full border border-white/15 bg-black/30 px-2 py-0.5 text-xs text-white/75">{item.status}</span>
              </div>
              <div className="mt-1 text-sm text-white/75">From {item.pro?.name || item.pro?.handle || 'Pro'}</div>
              <div className="mt-1 text-sm text-white/90">{item.amount_pixe || '0'} PIXE</div>
              {item.approx_usd ? <div className="mt-0.5 text-xs text-white/60">~ ${item.approx_usd}</div> : null}
            </Link>
          ))}
        </div>
      </main>
    </div>
  )
}
